<div class="AnnouncementsSection">
    <cx-page-slot position="Section3"></cx-page-slot>
</div>
<div class="warrantyTabsSection">
    <app-warranty-tabs></app-warranty-tabs>
</div>